export default "__VITE_ASSET__Cd$EHML4__"